/**
 * 通用工具类
 */
// import func from "@/util/func.js"

export default class func {
  /**
   * 不为空
   * @param val
   * @returns {boolean}
   */
  static notEmpty(val) {
    return !this.isEmpty(val);
  }

  /**
   * 是否为定义
   * @param val
   * @returns {boolean}
   */
  static isUndefined(val) {
    return val === null || typeof val === "undefined";
  }

  /**
   * 为空
   * @param val
   * @returns {boolean}
   */
  static isEmpty(val) {
    if (
      val === null ||
      typeof val === "undefined" ||
      (typeof val === "string" && val === "" && val !== "undefined")
    ) {
      return true;
    }
    return false;
  }

  static objIsEmpty(obj) {
    // if (
    //   val === null ||
    //   typeof val === 'undefined' ||
    //   (typeof val === 'string' && val === '' && val !== 'undefined')
    // ) {
    //   return true;
    // }
    // return false;
    if (Object.keys(obj).length === 0) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 强转int型
   * @param val
   * @param defaultValue
   * @returns {number}
   */
  static toInt(val, defaultValue) {
    if (this.isEmpty(val)) {
      return defaultValue === undefined ? -1 : defaultValue;
    }
    const num = parseInt(val, 0);
    return Number.isNaN(num)
      ? defaultValue === undefined
        ? -1
        : defaultValue
      : num;
  }

  /**
   * Json强转为Form类型
   * @param obj
   * @returns {FormData}
   */
  static toFormData(obj) {
    const data = new FormData();
    Object.keys(obj).forEach((key) => {
      data.append(key, Array.isArray(obj[key]) ? obj[key].join(",") : obj[key]);
    });
    return data;
  }

  /**
   * date类转为字符串格式
   * @param date
   * @param format
   * @returns {null}
   */
  static format(date, format = "YYYY-MM-DD HH:mm:ss") {
    return date ? date.format(format) : null;
  }

  /**
   * 根据逗号联合
   * @param arr
   * @returns {string}
   */
  static join(arr) {
    return arr ? arr.join(",") : "";
  }

  /**
   * 根据逗号分隔
   * @param str
   * @returns {string}
   */
  static split(str) {
    return str ? String(str).split(",") : "";
  }

  /**
   * 拷贝数组
   */
  static copyArr(arr) {
    return JSON.parse(JSON.stringify(arr));
  }

  /**
   * 单价数量算总价
   * 先简单写 以后根据需求调整
   */
  static suntotal(price, num) {
    if (this.isEmpty(price) || this.isEmpty(num)) {
      return 0.0;
    }

    let total = Number(price) * Number(num);
    total = total.toFixed(2);
    return total;
  }

  /**
   * 遍历数组获取父节点数组
   *
   */
  static getParentlist(arrs) {
    let alllist = [];

    arrs.forEach((arrs) => {
      alllist.push({
        id: arrs.id,
        parentId: 0,
      });

      if (arrs.itemCombCategoryList.length > 0) {
        (function getall(arr) {
          arr.forEach((item) => {
            alllist.push({
              id: item.id,
              parentId: item.parentId,
            });
            if (item.hasChildren) {
              getall(item.children);
            }
          });
        })(arrs.itemCombCategoryList);
      }
    });
    return alllist;
  }

  static getchildTolist(arr) {
    let list = [];

    (function addchild(arr) {
      arr.forEach((item) => {
        list.push(item);
        if (item.hasChildren) {
          addchild(item.children);
        }
      });
    })(arr);
    return list;
  }

  static testStrnum(str, num) {
    /****
     *
     *
     * if (func.testStrnum(subdata.ruleName,16)) {
              this.$message.error('排班名称不能超过16个字符');
              return
       }
     *
     */
    //检验字符串长度
    if (this.isEmpty(str)) {
      return false;
    }
    let val = str.toString();

    if (Number(val.length) > num) {
      return true;
    }
    return false;
  }

  static getlogtype(name) {
    const logtype = {
      预约管理: "appoint",
      患者随访: "patient_followup",
      患者咨询: "patient_consult",
      回访管理: "return_visit",
      收费划扣: "charge_deduction",
      电子病历: "emr",
    };
    let a = logtype[name];
    if (this.isEmpty(a)) {
      return false;
    }
    return a;
  }

  static getParam(url, name) {
    try {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = url.split("?")[1].match(reg);
      if (r != null) {
        return r[2];
      }
      return false; //如果此处只写return;则返回的是undefined
    } catch (e) {
      return false; //如果此处只写return;则返回的是undefined
    }
  }

  static removeRepet(list, key) {
    //根据数组的某个值去重
    let map = new Map();
    list.forEach((item) => {
      if (!map.has(item[key])) map.set(item[key], item);
    });
    return [...map.values()];
  }

  //清空对象里所有的值
  static clearObj(obj) {
    for (let key in obj) {
      obj[key] = "";
    }
    return obj;
  }

  //将obj2对象里的值合入obj1（没有则不合）
  static findaddObj(obj1, obj2) {
    Object.keys(obj1).forEach((key) => {
      if (!func.isEmpty(obj2[key])) {
        obj1[key] = obj2[key];
      }
    });
    return obj1;
  }

  static getOptionsName(arr, id, value = "value", label = "name") {
    //返回数组里头值的name
    let name = "";
    let item = arr.find((item) => {
      return item[value] == id;
    });
    if (!this.isEmpty(item)) {
      name = item[label];
    }
    return name;
  }

  static timeEmptyAdd(arr, params, name1, name2) {
    //传入时间数组如果两个都为空的判断
    if (!arr || this.isEmpty(arr)) {
      return params;
    }

    if (arr.length >= 2 && !this.isEmpty(arr[0]) && !this.isEmpty(arr[1])) {
      params[name1] = arr[0];
      params[name2] = arr[1];
      return params;
    }

    if (!this.isEmpty(arr[0])) {
      params[name1] = arr[0];
    }

    if (!this.isEmpty(arr[1])) {
      params[name2] = arr[1];
    }
    return params;
  }
}
